/**
 * Turn a map into an object
 *
 * @param {Map} map
 * @returns {Object} - object representation of the provided map
 */
const toObject = map => {
  let obj = {};

  map.forEach((value, key) => { obj[key] = value; });

  return obj;
};

export default {
  toObject
};
